'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (val) {
  // Replace closing
  var re = /<\/\W*script/gi;
  return val.replace(re, '(/script');
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-on-rails/node_package/lib/scriptSanitizedVal.js
 ** module id = 707
 ** module chunks = 0
 **/